import { graphQueryBang } from "shared/lib/graphql"
import { gql } from "shared/lib/graphql"

const ValidatePromoCodeMutation = gql`
  mutation($code: String!) {
    validatePromoCode(input: { code: $code }) {
      name
    }
  }
`

export const validatePromoCode = async code => {
  const response = await graphQueryBang(ValidatePromoCodeMutation, { code })
  return response.validatePromoCode
}
